import axios from 'axios';
import { api_prefix } from '../../Constants/constants';
import { releaseNotesReceived } from '../reducers/ReleaseNotes';
import { put, takeLatest } from 'redux-saga/effects';
import { showError } from '../../CommonUtilities/CommonUtilities';
import { defaultGetResponse } from '../../GetResponse';

function* getReleaseNotesSaga() {
  try {
    const json = yield axios
      .get(`${api_prefix}releases/?ordering=-version`)
      .then((response) => response?.data);
    yield put(releaseNotesReceived({ releaseNotes: json }));
  } catch (error) {
    yield put(releaseNotesReceived({ releaseNotes: defaultGetResponse }));
    showError(error);
  }
}

export default function* watchReleaseNotes() {
  yield takeLatest('ReleaseNotes/getReleaseNotes', getReleaseNotesSaga);
}
